import { useState } from 'react';

const CACHE_KEY = 'quotly_detected_currency';
const VALID = ['INR', 'USD'];

const getUrlCurrencyOverride = () => {
  const param = new URLSearchParams(window.location.search).get('currency');
  return param && VALID.includes(param.toUpperCase()) ? param.toUpperCase() : null;
};

const detectCurrencyFromTimezone = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    return tz === 'Asia/Kolkata' || tz === 'Asia/Calcutta' ? 'INR' : 'USD';
  } catch {
    return 'INR';
  }
};

const resolveInitialCurrency = () => {
  const urlOverride = getUrlCurrencyOverride();
  if (urlOverride) return urlOverride;
  const cached = sessionStorage.getItem(CACHE_KEY);
  if (cached && VALID.includes(cached)) return cached;
  const detected = detectCurrencyFromTimezone();
  sessionStorage.setItem(CACHE_KEY, detected);
  return detected;
};

const useDetectCurrency = () => {
  const [currency, setCurrencyState] = useState(resolveInitialCurrency);

  const setCurrency = (next) => {
    if (!VALID.includes(next)) return;
    sessionStorage.setItem(CACHE_KEY, next);
    setCurrencyState(next);
  };

  return { currency, loading: false, setCurrency };
};

export default useDetectCurrency;
